import { createContext } from 'react'

export type SnackbarSeverity = 'success' | 'error' | 'warning' | 'info'

export interface SnackbarContextValue {
  showSuccess: (message: string) => void
  showError: (message: string) => void
  showWarning: (message: string) => void
  showInfo: (message: string) => void
}

// Kept in its own module so `useSnackbar` can consume the context without
// importing the provider (which would pull MUI into every consumer's graph).
export const SnackbarContext = createContext<SnackbarContextValue | null>(null)
